import AutomaticSaleModal from './automatic-sale-modal';

export default AutomaticSaleModal;
